import React from 'react';
import Container from './Container';

const Features = () => {
  const features = [
    {
      id: 1,
      tag: "Smart Booking",
      title: "Online Ραντεβού με <span style={{ color: '#10B981' }}>Πλήρη Έλεγχο</span>",
      description: "Οι πελάτες κλείνουν ραντεβού online, αλλά εσείς έχετε τον τελικό λόγο. Το σύστημα αναλαμβάνει την επικοινωνία μόλις δώσετε το 'Ok'.",
      benefits: [
        "Δυνατότητα Manual Έγκρισης (Approve/Reject)",
        "Άμεση επιβεβαίωση μέσω Email",
        "Αυτόματη υπενθύμιση 3 ώρες πριν το ραντεβού"
      ],
      visual: (
        <div style={{ background: '#1F2937', padding: '1.5rem', borderRadius: '1rem', border: '1px solid #374151' }}>
          <div style={{ color: 'white', fontWeight: '600', marginBottom: '1rem', fontSize: '0.9rem' }}>Εκκρεμές Ραντεβού:</div>
          <div style={{ background: '#2D3748', padding: '12px', borderRadius: '8px', display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
            <span style={{ color: '#D1D5DB', fontSize: '0.85rem' }}>Max - 18:30</span>
            <div style={{ display: 'flex', gap: '8px' }}>
              <div style={{ backgroundColor: '#10B981', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '0.7rem' }}>Έγκριση</div>
              <div style={{ backgroundColor: '#EF4444', color: 'white', padding: '4px 8px', borderRadius: '4px', fontSize: '0.7rem' }}>Άκυρο</div>
            </div>
          </div>
        </div>
      )
    },
    {
      id: 2,
      tag: "Pet Care",
      title: "Ψηφιακό <span style={{ color: '#10B981' }}>Ιστορικό & Υπενθυμίσεις</span>",
      description: "Κάθε κατοικίδιο έχει τη δική του ψηφιακή καρτέλα. Οργανώστε τα πάντα και αφήστε το σύστημα να θυμάται τις ιατρικές υποχρεώσεις.",
      benefits: [
        "Email υπενθύμισης για εμβόλια & χάπια",
        "Πλήρες ιστορικό εξετάσεων & διαγνώσεων",
        "Γρήγορη αναζήτηση πελάτη & κατοικιδίου"
      ],
      visual: (
        <div style={{ background: '#1F2937', padding: '1.5rem', borderRadius: '1rem', border: '1px solid #374151' }}>
          <div style={{ color: 'white', marginBottom: '1rem', fontWeight: '700', fontSize: '1rem' }}>Καρτέλα: Max</div>
          <div style={{ display: 'flex', flexDirection: 'column', gap: '8px' }}>
            <div style={{ background: '#2D3748', padding: '8px', borderRadius: '6px', fontSize: '0.8rem', color: '#10B981' }}>✓ Εμβόλιο Λύσσας</div>
            <div style={{ background: '#2D3748', padding: '8px', borderRadius: '6px', fontSize: '0.8rem', color: '#F59E0B' }}>! Επόμενος Καθαρισμός</div>
          </div>
        </div>
      )
    },
    {
      id: 3,
      tag: "Operations",
      title: "Απόλυτος Έλεγχος <span style={{ color: '#10B981' }}>Αποθήκης</span>",
      description: "Μην αφήνετε την έλλειψη αποθέματος να σας σταματά. Παρακολουθήστε φάρμακα και αναλώσιμα σε πραγματικό χρόνο.",
      benefits: [
        "Ειδοποιήσεις για χαμηλό απόθεμα",
        "Οργάνωση ανά κατηγορία & προμηθευτή",
        "Μείωση σπατάλης και ληγμένων προϊόντων"
      ],
      visual: (
        <div style={{ background: '#1F2937', padding: '1.5rem', borderRadius: '1rem', border: '1px solid #374151' }}>
          <table style={{ width: '100%', color: '#D1D5DB', fontSize: '0.8rem' }}>
            <tbody>
              <tr><td style={{ padding: '4px 0' }}>Bravecto 20mg</td><td style={{ textAlign: 'right', color: '#EF4444' }}>2 τεμ.</td></tr>
              <tr><td style={{ padding: '4px 0' }}>Advantix</td><td style={{ textAlign: 'right', color: '#10B981' }}>18 τεμ.</td></tr>
            </tbody>
          </table>
        </div>
      )
    }
  ];

  return (
    <section id="features" style={{ padding: '6rem 0', backgroundColor: '#1A202C' }}>
      <Container>
        <div style={{ textAlign: 'center', marginBottom: '5rem' }}>
          <h2 style={{ fontSize: '2.5rem', fontWeight: '800', color: 'white', marginBottom: '1.25rem' }}>
            Όλα όσα χρειάζεται ένα <br />
            <span style={{ color: '#10B981' }}>σύγχρονο κτηνιατρείο</span>
          </h2>
        </div>

        {features.map((f, idx) => (
          <div key={f.id} style={{ 
            display: 'grid', 
            gridTemplateColumns: 'repeat(auto-fit, minmax(300px, 1fr))', 
            gap: '5rem', 
            alignItems: 'center',
            marginBottom: '6rem',
            direction: idx % 2 === 0 ? 'ltr' : 'rtl'
          }}>
            <div style={{ direction: 'ltr' }}>
              <span style={{ color: '#10B981', fontWeight: '700', fontSize: '0.85rem', textTransform: 'uppercase' }}>{f.tag}</span>
              <h3 style={{ color: 'white', fontSize: '2rem', fontWeight: '700', marginTop: '0.5rem', marginBottom: '1.25rem' }} dangerouslySetInnerHTML={{ __html: f.title }} />
              <p style={{ color: '#94A3B8', fontSize: '1.1rem', lineHeight: '1.6', marginBottom: '1.5rem' }}>{f.description}</p>
              <ul style={{ listStyle: 'none', padding: 0 }}>
                {f.benefits.map(b => (
                  <li key={b} style={{ color: 'white', display: 'flex', alignItems: 'center', gap: '0.75rem', marginBottom: '0.75rem', fontSize: '1rem' }}>
                    <svg style={{ width: '1.25rem', height: '1.25rem', color: '#10B981', flexShrink: 0 }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="3" d="M5 13l4 4L19 7" /></svg>
                    {b}
                  </li>
                ))}
              </ul>
            </div>
            <div style={{ 
              background: 'linear-gradient(135deg, #2D3748 0%, #111827 100%)', 
              padding: '2.5rem', 
              borderRadius: '2rem', 
              border: '1px solid #374151',
              direction: 'ltr'
            }}>
              {f.visual}
            </div>
          </div>
        ))}

        {/* Small & Clean CTA Section */}
        <div style={{ textAlign: 'center', marginTop: '4rem' }}>
          <div style={{ 
            background: 'linear-gradient(90deg, #10B981 0%, #3B82F6 100%)', 
            padding: '3rem 2rem', 
            borderRadius: '1.5rem', 
            display: 'inline-block',
            width: '100%',
            maxWidth: '900px',
            boxShadow: '0 15px 30px rgba(0,0,0,0.2)'
          }}>
            <h3 style={{ color: 'white', fontSize: '2rem', fontWeight: '800', marginBottom: '1.5rem' }}>
              Ξεκινήστε για 30 ημέρες δωρεάν
            </h3>
            <button style={{ 
              backgroundColor: 'white', 
              color: '#111827', 
              padding: '1rem 3rem', 
              borderRadius: '0.75rem', 
              fontWeight: '800', 
              border: 'none', 
              cursor: 'pointer',
              fontSize: '1.1rem',
              transition: 'transform 0.2s'
            }}
            onMouseEnter={(e) => e.target.style.transform = 'scale(1.05)'}
            onMouseLeave={(e) => e.target.style.transform = 'scale(1)'}
            >
              Δημιουργία Λογαριασμού
            </button>
          </div>
          
          {/* Info Text OUTSIDE the card */}
          <p style={{ color: '#94A3B8', marginTop: '1.5rem', fontSize: '0.95rem' }}>
            <svg style={{ width: '1rem', height: '1rem', verticalAlign: 'middle', marginRight: '6px', color: '#10B981' }} fill="none" stroke="currentColor" viewBox="0 0 24 24"><path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z" /></svg>
            Δεν απαιτείται πιστωτική κάρτα. Θα χρειαστεί μόνο αν επιλέξετε να συνεχίσετε μετά τη δοκιμή.
          </p>
        </div>
      </Container>
    </section>
  );
};

export default Features;